import { motion } from "motion/react";
import styled from "styled-components";

import {
  DATA_E2E_KEY,
  IStyledAttributes,
  RIGHTBAR_DEFAULT_WIDTH_MOBILE,
} from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

export const DrawerMotionMenuWrapperStyled = styled(
  motion.div,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drawer-motion-menu-wrapper-styled",
})`
  background-color: ${rydeColors.white};
  position: absolute;
  width: ${props => props.custom};
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  padding: 0;
  border-inline-end: 1px solid ${greyMui._300};
  display: flex;
  flex-direction: column;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    border-inline-end: initial;
    inset-inline-start: initial;
    inset-inline-end: 0;
    border-inline-start: 1px solid ${greyMui._300};
    width: ${RIGHTBAR_DEFAULT_WIDTH_MOBILE};
  }
`;
